import { styled } from '@linaria/react';
import { fonts, layout, semantic, space } from '../../theme/tokens';

export const Heading = styled.h1<{ $flush?: boolean }>`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: ${semantic.text.primary};
  text-align: center;
  margin: 0 auto ${({ $flush }) => ($flush ? '0' : space[6])};
  max-width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
    max-width: ${({ $flush }) => ($flush ? '100%' : '75%')};
  }
`;

export const Subtitle = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;
